var _a;
import './bootstrap';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { Integrations } from '@sentry/tracing';
import { CONFIG } from '../common/config';
import store from './store';
import ScrollToTop from './components/ScrollToTop';
import App from './components/App';
import { Provider } from 'react-redux';
import './i18n';
if ((_a = CONFIG.SENTRY) === null || _a === void 0 ? void 0 : _a.DSN) {
    Sentry.init({
        dsn: CONFIG.SENTRY.DSN,
        integrations: [new Integrations.BrowserTracing()],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 1.0,
    });
}
ReactDOM.render(
// <React.StrictMode>
React.createElement(Suspense, { fallback: null },
    React.createElement(Provider, { store: store },
        React.createElement(BrowserRouter, null,
            React.createElement(ScrollToTop, null),
            React.createElement(App, null)))), 
// </React.StrictMode>,
document.getElementById('app'));
